import { createContext } from "react";

export const SidebarState = createContext({
  isOpen: false,
  width: 0,
});
